import { useRef } from 'react';

export const useAnchors = qty => {
    const ref = useRef(null);
    return Array.from({ length: qty }, () => ref);
};
